import {Observable} from 'rxjs';


export function isScrollableImage(imageWidth: number, imageHeight: number) {
    // image with very long height is better handled by fitting the width and scrolling the height
   return imageHeight > imageWidth * 2.5;
}

export function isScrollableImage$(imgUrl: string): Observable<boolean> {
    return new Observable<boolean>((observer) => {
        const image = new Image();
        image.setAttribute('crossOrigin', 'anonymous');
        image.onload = () => {
            observer.next(isScrollableImage(image.width, image.height));
            observer.complete();
        };
        image.onerror = () => {
            observer.error("Failed to load image");
        };
        image.src = imgUrl;
        return () => {
            image.onload = null;
            image.onerror = null;
        };
    });
}